import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { webappRoute } from "./layout"

export const webappIndexRoute = createRoute({
  getParentRoute: () => webappRoute,
  // Index of the /webapp parent (relative path).
  path: "/",
  component: lazyRouteComponent(() => import("./lazy-pages"), "AdvisorsPage"),
})
